@if(componentUniqueId){
<mat-slide-toggle [checked]="checked" [disabled]="disabled || loading" (change)="onToggle($event)">
    {{ label }}
</mat-slide-toggle>
}